import { Component, HostBinding } from '@angular/core';
import { AptitudeNavService } from './aptitudeNav.service';
import { filter } from 'lodash-es';
import { combineLatest } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { StonlyService } from '../../../services/stonly.service';
import { Features } from '../../../types/features';
import {
  ApplicationRoutesService,
  Route,
} from '../../../services/application-routes.service';
import { TokenFacade } from '../../../services/token-facade.service';
import { User } from '../../../types/user/user';
import { JwtPayload } from '../../../services/tokenKeeper';

@Component({
    selector: 'app-apt-header',
    templateUrl: './apt-header.component.html',
    styleUrls: ['./apt-header.component.scss'],
    standalone: false
})
export class AptHeaderComponent {
  @HostBinding('class') classes = 'flex-column';
  currentUser?: User;
  itemsLeft: any;
  itemsRight: any;
  logoUrl = 'assets/aptLogoImgs/aptitude Logo.svg';
  features: Features = {};

  constructor(
    private aptitudeNavHelper: AptitudeNavService,
    public route: ActivatedRoute,
    private applicationRoutes: ApplicationRoutesService,
    tokenFacade: TokenFacade,
    private stonlyService: StonlyService,
  ) {
    combineLatest([tokenFacade.tokenPayload$, route.data]).subscribe(
      ([tokenPayload, data]) => {
        this.currentUser = data['currentUser'];
        this.features = data['features'];
        this.loadNavItems(data['currentUser'], data['features'], tokenPayload);
      },
    );
  }

  loadNavItems(
    currentUser: User,
    features: Features,
    tokenPayload: JwtPayload,
  ) {
    /* Stonly-12 Changes applied */
    const stonlyUser = currentUser.emailAddress;
    this.stonlyService.stonlyTrackFn(stonlyUser, {
      isbuyer: currentUser && currentUser.isBuyer,
    });

    // It's definitely a kludge to set Stonly and Datadog info here in the apt-header, but unlike
    // the sign-in it is going to work even as the user transitions back and forth between
    // AngularJS and Angular as well as when they come back to the app via emails or browser
    // links and don't need to authenticate again.
    //
    // There are other places we could do it, but most of those don't have access to the current
    // user info.
    datadogLogs.setUser({
      email: currentUser.emailAddress,
      name: currentUser.fullName,
      orgId: currentUser.organization.id,
      orgName: currentUser.organization.name,
      orgType: currentUser.organization.organizationType,
      id: currentUser.userId?.toString(),
    });

    datadogRum.setUser({
      email: currentUser.emailAddress,
      name: currentUser.fullName,
      orgId: currentUser.organization.id,
      orgName: currentUser.organization.name,
      orgType: currentUser.organization.organizationType,
      id: currentUser.userId?.toString(),
    });

    this.itemsLeft = this.aptitudeNavHelper.getLeftItems(
      currentUser,
      features,
      tokenPayload,
    );
    this.itemsRight = this.aptitudeNavHelper.getRightItems(
      currentUser,
      features,
      tokenPayload,
    );
  }

  show(item: any) {
    return item.test ? item.test() : true;
  }

  available(menu: any) {
    return filter(menu, this.show);
  }

  getHomePathByOrgType(): string {
    return this.applicationRoutes.get(Route.HOME_LANDING);
  }
}
